const BudgetComponent = () => import('@/views/finance/Budget/BudgetView')

export default [
    {
        path:'/BudgetIndex',
        name:'BudgetComponent',
        component:BudgetComponent
    }
]